import React, { FC, useEffect, useState } from 'react';
import { Select } from 'antd';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
	brandsRestCrudThunksForBuyer,
	brandsRestCrudThunksForSupplier,
} from '../../thunks/brands_thunks';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const BrandSelection: FC<any> = ({
	disabled = false,
	value,
	onChange,

	setHasBrands,
	fetchBrands,
}) => {
	const [options, setOptions] = useState([]);

	useEffect(() => {
		fetchBrands({}).then((data) => {
			setOptions(data);
			if (nullSafeGetOrElse('length', data, 0) > 0 && setHasBrands) {
				setHasBrands(true);
			}
		});
	}, []);

	return (
		<Select mode="multiple" disabled={disabled} allowClear={true} value={value} onChange={onChange}>
			{options.map((option) => (
				<Select.Option key={option.id} value={option.id}>
					{option.brandName}
				</Select.Option>
			))}
		</Select>
	);
};

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchBrands: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandsRestCrudThunksForSupplier.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: brandsRestCrudThunksForBuyer.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(BrandSelection)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
